import React, { useState, useMemo } from 'react'

import CheckBox from './CheckBox'

// Canadian-only opt-in for a CRA-eligible tax receipt. Adapted from
// donate_v6/useCanadianReceipt.jsx. Hardcoded English copy — the
// feature is Canada-only and the translation surface isn't worth
// dragging across 22 locales for one market. value is what flows
// into the order draft (canadian_receipt) and into useDonation's
// collectAddress derivation, so a Canadian-receipt opt-in implies
// AddressElement on Contact.
const useCanadianReceipt = ({ partnerItem, partner_items }) => {
  const available = useMemo(() =>
    partnerItem.beneficiary.canada_helps || (
      partnerItem.beneficiary.id == '_multiple' &&
      partner_items.some(pi => pi.beneficiary.canada_helps)
    )
  , [ partnerItem.external_id ])

  // Default to opted-in when every beneficiary in scope supports it
  // — matches v6 behavior. In a split fundraiser where some
  // beneficiaries don't qualify, default to off so the donor opts in
  // explicitly.
  const [ checked, setChecked ] = useState(() =>
    available && (
      partner_items.length
        ? partner_items.every(pi => pi.beneficiary.canada_helps)
        : partnerItem.beneficiary.canada_helps
    )
  )

  const render = () =>
    available && (
      <CheckBox
        id="canadianReceipt"
        label="I would like a Canadian tax receipt"
        checked={checked}
        onChange={e => setChecked(e.target.checked)}
      />
    )

  return { available, render, value: available && checked }
}

export default useCanadianReceipt
